import http from './api';

const updateTheme = (orgId, uri, theme) => http.patch(`api/organization-theme/${orgId}?uri=${uri}`, theme);
const getTheme = (organizationId, uri) => http.get(`api/organization-theme/${organizationId}?uri=${uri}`);
const saveMultipleThemes = (organizationId, uris, theme) =>
  http.post(`api/organization-theme/${organizationId}/multiple`, { theme, uris });
const getCustomizedUris = organizationId => http.get(`api/organization-theme/${organizationId}/customized-uri`);
const createTheme = theme => http.post('api/organization-theme', theme);
const deleteTheme = (organizationId, uri, updatedBy) =>
  http.delete(`api/organization-theme/${organizationId}?uri=${uri}&updatedBy=${updatedBy}`);

export default {
  updateTheme,
  getTheme,
  saveMultipleThemes,
  getCustomizedUris,
  createTheme,
  deleteTheme
};
